import { useContext } from 'react'

import { SettingsContext } from '../contexts/SettingsContext'

export function useSettings() {
  const {
    isDarkMode,
    currentTheme,
    isSoundEnabled,
    switchMode,
    switchTheme,
    switchSoundEnabled,
    preferences,
    isLoading,
    preferencesService,
  } = useContext(SettingsContext)

  const toggleTheme = async () => {
    await switchMode()
  }

  const setTheme = async (theme) => {
    await switchTheme(theme)
  }

  const toggleSoundEnabled = async () => {
    await switchSoundEnabled()
  }

  const updatePreference = async (key, value) => {
    if (preferencesService) {
      try {
        await preferencesService.updatePreference(key, value)
      } catch (error) {
        console.error(`Failed to update preference ${key}:`, error)
      }
    }
  }

  const resetPreferences = async () => {
    if (preferencesService) {
      try {
        await preferencesService.resetPreferences()
      } catch (error) {
        console.error('Failed to reset preferences:', error)
      }
    }
  }

  return {
    isDarkMode,
    currentTheme,
    isSoundEnabled,
    toggleTheme,
    setTheme,
    toggleSoundEnabled,
    preferences,
    isLoading,
    updatePreference,
    resetPreferences,
    preferencesService,
  }
}
